import { useEffect, useState } from 'react';
import { useWorkflowsService } from '../contexts/workflows-service';
import { UseWorkflowHook, Workflow, WorkflowsService } from '../ports/WorkflowService';

export function createUseWorkflow(
  {
    useWorkflowsService,
  }: {
    useWorkflowsService: () => WorkflowsService | undefined;
  },
): UseWorkflowHook {
  return function useWorkflow(id: string) {
    const workflowsService = useWorkflowsService();

    const [workflow, setWorkflow] = useState<Workflow>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error>();

    const update = () => {
      if (!workflowsService || isLoading) {
        return;
      }
      setIsLoading(true);
      workflowsService
        .getWorkflow(id)
        .then(setWorkflow)
        .catch(setError)
        .then(() => setIsLoading(false));
    };

    useEffect(
      () => {
        update();
      },
      [workflowsService, id],
    );

    return {
      workflow,
      isLoading,
      error,
      update,
    };
  };
}

export const useWorkflow =  createUseWorkflow({ useWorkflowsService });
